import { render } from "./TableTabs.vue?vue&type=template&id=4c21f410"
import script from "./TableTabs.vue?vue&type=script&lang=ts"
export * from "./TableTabs.vue?vue&type=script&lang=ts"

import "./TableTabs.vue?vue&type=style&index=0&id=4c21f410&lang=scss"
script.render = render

export default script